/** @jsx jsx */
// @flow

import { RouterSelectors, useRedux } from '@zapier/toolbox-redux-framework';
import { Header } from '@zapier/product-dev-platform';
import { Profile } from '@zapier/shared-entities';
import { Zindexes } from '@zapier/theme';
import { css, jsx } from '@emotion/core';

import { emitUserInteractionEvent } from './utils';
import { optionSelectedMap } from './constants';

const Styles = {
  root: css`
    z-index: ${Zindexes.headerFixedPosition};
    & button {
      color: inherit !important;
      background: none !important;
    }
  `,
};

const mapStateToProps = state => {
  const isLoggedIn = Profile.selectors.all.isLoggedIn(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const isLoadingUser = Profile.selectors.all.isLoadImpending(state);
  const user = isLoggedIn
    ? {
        name: Profile.selectors.normalizedName(currentProfile) || '',
        avatarUrl: Profile.selectors.gravatarUrl(currentProfile),
      }
    : undefined;

  return {
    currentUrl: RouterSelectors.currentUrl(state) || '',
    isLoadingUser,
    user,
  };
};

function PlatformHeaderContainer() {
  const { currentUrl, isLoadingUser, user } = useRedux(mapStateToProps);
  return (
    <div css={Styles.root}>
      <Header
        currentUrl={currentUrl}
        isLoadingUser={isLoadingUser}
        onClickLogOut={() => {
          emitUserInteractionEvent({
            eventAction: 'click',
            interactionGoal: 'Log out',
            interactionName: 'profile_menu_option_clicked',
            interactionRawText: 'Log Out',
            optionSelected: 'log out',
          });
        }}
        onClickNavLink={({ label }) => {
          emitUserInteractionEvent({
            eventAction: 'click',
            interactionGoal: 'Navigate using the top menu',
            interactionName: 'menu_item_clicked',
            interactionRawText: label,
            optionSelected: optionSelectedMap[label],
          });
        }}
        onClickSettings={() => {
          emitUserInteractionEvent({
            eventAction: 'click',
            interactionGoal: 'Navigate to settings',
            interactionName: 'profile_menu_option_clicked',
            interactionRawText: 'Settings',
            optionSelected: 'settings',
          });
        }}
        onClickZapier={() => {
          emitUserInteractionEvent({
            eventAction: 'click',
            interactionGoal: 'Navigate to zapier.com',
            interactionName: 'profile_menu_option_clicked',
            interactionRawText: 'zapier.com',
            optionSelected: 'zapier',
          });
        }}
        onClickZapTemplates={() => {
          emitUserInteractionEvent({
            eventAction: 'click',
            interactionGoal: 'Navigate to Zap templates',
            interactionName: 'profile_menu_option_clicked',
            interactionRawText: 'Zap Templates',
            optionSelected: 'templates',
          });
        }}
        onToggleUserDropdown={isOpen => {
          if (isOpen) {
            emitUserInteractionEvent({
              eventAction: 'open',
              interactionGoal: 'Open the profile menu',
              interactionName: 'profile_picture_clicked',
              interactionRawText: '',
              optionSelected: '',
            });
          }
        }}
        user={user}
      />
    </div>
  );
}

export default PlatformHeaderContainer;
